export const PATH_SEPARATOR = '/'
